import Reactx from 'react';
import {Result} from 'antd';


export const Forbidden = (props) => {

    return (
        <div className={`component sign_in`}>
            <div className="sign_in--wrp">
                <Result
                    status={"error"}
                    title={"Доступ запрещен"}
                    subTitle={"Для доступа к разделу пройдите авторизацию"}
                />
            </div>
        </div>
    );
};

export default Forbidden;